export const PrintDiscountTHeadLayout = () => {
	return (
		<div className="grid grid-cols-12 font-semibold">
			<div className="col-span-10 border border-zinc-200 p-1">
				<p>名称</p>
			</div>

			<div className="col-span-2 border border-zinc-200 p-1">
				<p>割引額</p>
			</div>
		</div>
	);
};
